/**
 * 页面公共处理handle
 * 一般用于 公共url参数，登陆状态，环境，渠道 等处理
 *
 * 1. URL 公共处理
 * 登陆信息处理:
 *  - tjuserid
 *  - tjusertoken
 * B端信息处理:
 *  - groupGuid
 *  - storeGuid
 * 2. 渠道处理 tj-channel
 * 3. 资源位 code sem 相关处理 sem-code
 */
import { setUserId, setUserToken, setGroupGuid, setStoreGuid } from '../tj-storage';
import channelUtil from '../tj-channel';
import { queryString } from '../utils/url-helper';
import { initUtmCode } from './sem-code';
/**
 * 检查用户信息一般来自APP&小程序
 */
function checkUserInfo() {
    var tjUserId = queryString('tjuserid');
    var tjUserToken = queryString('tjusertoken');
    if (tjUserId) {
        setUserId(tjUserId);
    }
    if (tjUserId === '0') {
        tjUserToken = '00000000-0000-0000-0000-000000000000';
    }
    if (tjUserToken) {
        setUserToken(tjUserToken);
    }
}
/**
 * 检查B端 相关信息，一般来自 APP
 */
function checkBClientInfo() {
    var groupGuid = queryString('groupGuid') ||
        queryString('groupguid') ||
        queryString('tjgroupguid');
    var storeGuid = queryString('storeGuid') ||
        queryString('storeguid') ||
        queryString('tjstoreguid');
    // 一站式管理页面cookie中写入storeGuid和GroupGuid
    if (groupGuid) {
        setGroupGuid(groupGuid);
    }
    if (storeGuid) {
        setStoreGuid(storeGuid);
    }
}
export function initPageCommonHandle() {
    channelUtil.initTujiaChannel();
    checkUserInfo();
    checkBClientInfo();
    initUtmCode();
}
